import styled, { css } from 'styled-components';
import { ReactComponent as _Arrow } from 'styles/icons/arrow.svg';
import { withModifiers } from 'utils/styles';

const size = css`
  width: 10px;
  height: 10px;
`;

export const Rect = styled.div`
  ${size};
  background-color: ${({ color }) => color};
`;

export const Circle = styled.div`
  ${size};
  background-color: ${({ color }) => color};
  border-radius: 50%;
`;

export const Arrow = styled(_Arrow)`
  width: 12px;
  height: 12px;
  color: ${({ color }) => color};

  ${withModifiers('$start')`
    transform: rotate(270deg);
    margin-right: -6px;
  `}

  ${withModifiers('$end')`
    transform: rotate(90deg);
    margin-left: -6px;
  `}
`;
